import { Image } from 'react-bootstrap';
import classes from './ImageStrip.module.scss';

export const ImageStrip = ({ images = [], height = 100, onImageClick, onAddImage, showAddButton = false }) => {
  if (!showAddButton && (!images || images.length === 0)) { return null; }

  return (
    <div className={`${classes.thumbnailStrip}`} style={{ height: `${height}px` }}>
      <div className={classes.thumbnailContainer}>
        {images.map((image, index) => (
          <div
            key={image.id || index}
            className={classes.thumbnailWrapper}
            onClick={() => onImageClick && onImageClick(image, index)}
          >
            <Image
              src={image.thumb_url}
              alt={image.name || `Image ${index + 1}`}
              className={classes.thumbnail}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className={classes.fallback}>
              <i className="bi bi-image"></i>
              <span>{image.name || `Image ${index + 1}`}</span>
            </div>
          </div>
        ))}

        {showAddButton && (
          <div className={classes.addButtonWrapper} onClick={onAddImage} title={__('Add Image')} role="button" tabIndex={0} />
        )}
      </div>
    </div>
  );
}; 